import axios from "axios";
import config from "../config";

const instance = axios.create({
  baseURL: config.REACT_APP_API_ENDPOINT,
  headers: { "Content-Type": "application/json" },
});

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("Token");
    if (token && token !== "undefined" && token !== "null") {
      config.headers["Authorization"] = "Bearer " + token;
    }
    const division = sessionStorage.getItem("Division");
    if (division) {
      config.headers["X-Division"] = division;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // v1 routes return { success, data } — pass through directly
    if (response?.data?.success !== undefined) {
      if (!response.data.success) {
        return Promise.reject(response.data.error || 'Request failed');
      }
      return response.data;
    }

    if (response?.data?.statusCode === "10001") {
      sessionStorage.clear();
      window.location.href = (config.REACT_APP_URL || window.location.origin) + '/';
      return Promise.reject(response.data.msg || response.data.statusMsg);
    }

    if (response?.data?.statusCode !== "0000") {
      return Promise.reject(response.data.msg || response.data.statusMsg);
    }

    return response?.data ?? response;
  },
  function (error) {
    // Handle 401 Unauthorized - session expired
    if (error?.response?.status === 401) {
      sessionStorage.clear();
      window.location.href = (config.REACT_APP_URL || window.location.origin) + '/';
      return Promise.reject("Session expired. Please login again.");
    }
    
    // Handle 409 Conflict - session conflict, pass through for App.js to handle
    if (error?.response?.status === 409) {
      return Promise.reject(error);
    }
    
    // Handle 423 Locked - session taken over by another device
    if (error?.response?.status === 423 && error?.response?.data?.statusCode === '4231') {
      sessionStorage.clear();
      window.dispatchEvent(new CustomEvent('sessionKicked'));
      return Promise.reject("Your session has been taken over by another device.");
    }
    
    // Handle 423 for account lockout (statusCode 4291)
    if (error?.response?.status === 423) {
      return Promise.reject(error?.response?.data?.statusMsg || "Account locked.");
    }

    if (error?.response?.data?.msg || error?.response?.data?.statusMsg) {
      return Promise.reject(error.response.data.msg || error.response.data.statusMsg);
    }

    return Promise.reject("Unable to process request");
  }
);

export default instance;
